import {ModuleWithProviders, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MomentPipe} from '../pipes/moment.pipe';
import {CometchatService} from '../services/cometchat.service';
import {LocationService} from '../services/location.service';
import {LocalstorageService} from '../services/localstorage.service';
import {TranslateModule} from '@ngx-translate/core';
import {IonicModule} from '@ionic/angular';
import {CategorySelectorComponent} from './category-selector/category-selector.component';
import {CommonModule} from '@angular/common';
import {DistanceSelectorComponent} from './distance-selector/distance-selector.component';
import {EmptyDataComponent} from './empty-data/empty-data.component';
import {AuthService} from '../services/auth.service';
import {LoadingService} from '../services/loading.service';
import {UserService} from '../services/user.service';
import {AuthCallbackComponent} from './auth-callback/auth-callback.component';
import {RegistrationAuthCallbackComponent} from './auth-callback/registration-auth-callback.component';
import {PushNotificationService} from '../services/push-notification.service';
import {TranslateFieldPipe} from '../pipes/translate-field.pipe';
import {FieldFormatPipe} from '../pipes/field-format.pipe';
import {LinkifyPipe} from '../pipes/linkify.pipe';
import {UrlNormalizerPipe} from '../pipes/url-normalizer.pipe';
import {SoundService} from '../services/sound.service';
import {RtcService} from '../services/rtc.service';
import {EtaService} from '../services/eta.service';
import {TrackingService} from '../services/tracking.service';
import {LinkifyClickDirective} from './linkify-click/linkify-click.directive';
import {LogoComponent} from './logo/logo.component';
import {AvatarComponent} from './avatar/avatar.component';
import {EtaStatusTimePipe} from '../pipes/eta-status-time.pipe';
import {DesktopNotificationService} from '../services/desktop-notification.service';
import {ModalVideoViewerComponent} from './modal-video-viewer/modal-video-viewer.component';
import {MediaPickerComponent} from './modal-media-picker/media-picker/media-picker.component';
import {MediaInputComponent} from './modal-media-picker/media-input/media-input.component';
import {ModalMediaPickerComponent} from './modal-media-picker/modal-media-picker.component';
import {TooltipDirective} from './tooltip/tooltip.directive';

@NgModule({
    declarations: [
        AuthCallbackComponent,
        AvatarComponent,
        CategorySelectorComponent,
        DistanceSelectorComponent,
        EmptyDataComponent,
        EtaStatusTimePipe,
        FieldFormatPipe,
        LinkifyClickDirective,
        LinkifyPipe,
        LogoComponent,
        MediaPickerComponent,
        MediaInputComponent,
        ModalVideoViewerComponent,
        ModalMediaPickerComponent,
        MomentPipe,
        RegistrationAuthCallbackComponent,
        TooltipDirective,
        TranslateFieldPipe,
        UrlNormalizerPipe
    ],
    imports: [
        IonicModule,
        CommonModule,
        FormsModule,
        TranslateModule
    ],
    exports: [
        AvatarComponent,
        CategorySelectorComponent,
        DistanceSelectorComponent,
        EmptyDataComponent,
        EtaStatusTimePipe,
        FieldFormatPipe,
        FormsModule,
        LinkifyClickDirective,
        LinkifyPipe,
        LogoComponent,
        MediaPickerComponent,
        MediaInputComponent,
        ModalMediaPickerComponent,
        ModalVideoViewerComponent,
        MomentPipe,
        ReactiveFormsModule,
        TooltipDirective,
        TranslateFieldPipe,
        TranslateModule,
        UrlNormalizerPipe
    ],
    providers: [
        FieldFormatPipe
    ]
})

export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        AuthService,
        UserService,
        LocalstorageService,
        LoadingService,
        RtcService,
        CometchatService,
        SoundService,
        LocationService,
        EtaService,
        TrackingService,
        PushNotificationService,
        DesktopNotificationService
      ]
    };
  }
}
